import axios from "axios";
import { Config } from "../../../core/config/config";
import { t } from "i18next";

const GATEWAY_URL = `${Config.VITE_APP_GATEWAY_URL}/api/report/microstrategy`;

export const mstrService = {

    getSalesPerformanceReport: async function () {
        return axios.get(`${GATEWAY_URL}/sales-performance`)
            .then((response) => {
                return response.data;
            });
    },
    getStockReport: async function () {
        return axios.get(`${GATEWAY_URL}/stock`)
            .then((response) => {
                return response.data;
            });
    },
    getLiveSalesReport: async function () {
        return axios.get(`${GATEWAY_URL}/live-sales`)
            .then((response) => {
                return response.data;
            });
    },

    getSalesDetailAnalysis: async function () {
        return axios.get(`${GATEWAY_URL}/sales-detail-analysis`)
            .then((response) => {
                return response.data;
            });
    },
    getLFLSalesReport: async function () {
        return axios.get(`${GATEWAY_URL}/lfl-sales-report`)
            .then((response) => {
                return response.data;
            });
    },
    mstrLogin(host: any, username: any, password: any) {
        return new Promise<string | null>(function (resolve, reject) {
            const xhr = new XMLHttpRequest();
            xhr.open("POST", host + '/MicroStrategyLibrary/api/auth/login');
            xhr.withCredentials = true;
            xhr.setRequestHeader('Content-Type', 'application/json');
            xhr.setRequestHeader("Accept", "application/json");
            xhr.send(JSON.stringify({
                username,
                password,
                loginMode: 1
            }));
            xhr.onreadystatechange = function () {
                if (xhr.readyState === 2) {
                    const token = xhr.getResponseHeader('x-mstr-authToken')
                    localStorage.setItem("mstr_token", token as string)
                    resolve(token);
                } else {
                    reject({
                        status: this.status,
                        statusText: xhr.statusText
                    });
                }
            };
        });
    },

    checkSession(host: any, token: any) {
        return new Promise<boolean>(function (resolve, reject) {
            const xhr = new XMLHttpRequest();
            xhr.open('GET', host + '/MicroStrategyLibrary/api/sessions', true);
            xhr.setRequestHeader('X-MSTR-AuthToken', token);
            xhr.withCredentials = true;
            xhr.onload = function () {
                if (xhr.status >= 200 && xhr.status < 300) {
                    resolve(true);
                } else {
                    resolve(false);
                }
            };

            xhr.onerror = function () {
                resolve(false);
            };

            xhr.send();
        });
    },
    logout(host: any, token: any) {
        return new Promise<boolean>(function (resolve, reject) {
            const xhr = new XMLHttpRequest();
            xhr.open("POST", host + '/MicroStrategyLibrary/api/auth/logout');
            xhr.withCredentials = true;
            xhr.setRequestHeader('Content-Type', 'application/json');
            xhr.setRequestHeader("Accept", "application/json");
            xhr.setRequestHeader('X-MSTR-AuthToken', token);
            xhr.send();
            xhr.onreadystatechange = function () {
                if (xhr.status >= 200 && xhr.status < 300) {
                    resolve(true);
                } else {
                    resolve(false);
                }
            };
        });
    },

}